<p-chart type="line" [data]="lineData" [options]="lineOptions" [style]="{'height': '50%'}"></p-chart>